var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    {
      style:
        !_vm.showBoardHandle && !_vm.$store.state.menu.collapse
          ? "width:100%"
          : "",
      attrs: { placement: "right-end", trigger: "hover" },
    },
    [
      _c(
        "div",
        { staticStyle: { padding: "12px 12px 0" } },
        [
          _vm._l(_vm.menuList, function (menu) {
            return _vm._l(menu.children, function (dict) {
              return _c(
                "div",
                {
                  key: dict.name,
                  staticClass: "directory",
                  staticStyle: { "max-width": "420px" },
                },
                [
                  dict.children
                    ? [
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "menu::" +
                                    dict["actionCode"]
                                      .split("::")
                                      .slice(1)
                                      .join("::")
                                )
                              ) +
                              " "
                          ),
                        ]),
                        _c(
                          "div",
                          { staticClass: "menuList" },
                          _vm._l(dict.children, function (item) {
                            return _c(
                              "div",
                              {
                                key: item.actionCode,
                                staticClass: "menu",
                                class: dict.name.split("::").slice(0),
                                on: {
                                  click: function ($event) {
                                    return _vm.toUrl(item)
                                  },
                                },
                              },
                              [
                                _vm.getImage(item.icon)
                                  ? _c("img", {
                                      staticClass: "menuIcon",
                                      attrs: { src: _vm.getImage(item.icon) },
                                    })
                                  : _c("i", {
                                      staticClass: "iconfont",
                                      class: item.icon,
                                    }),
                                _c("span", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "menu::" +
                                            item["actionCode"]
                                              .split("::")
                                              .slice(1)
                                              .join("::")
                                        )
                                      ) +
                                      " "
                                  ),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              )
            })
          }),
        ],
        2
      ),
      _c(
        "el-button",
        {
          staticClass: "menu-button self-btn",
          class: { "collapse-menu-button": _vm.$store.state.menu.collapse },
          style: !_vm.showBoardHandle ? "width:100%" : "margin-left:5px;",
          attrs: {
            slot: "reference",
            type: "primary",
            plain: "",
            size: "medium",
          },
          slot: "reference",
        },
        [
          _c("img", {
            staticStyle: { width: "24px", display: "inline-block" },
            attrs: { src: _vm.menus },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }